$(document).foundation();


/*** Wrap scrollable table ***/
$('table.contenttable').wrap('<div class="table-scroll"></div>');



	var cities = L.layerGroup();

	L.marker([47.04070,9.06765]).bindPopup('Physiotherapie Uta Muggli').addTo(cities);


	var mbAttr = 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
			'<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
			'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
		mbUrl = 'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw';

	var grayscale   = L.tileLayer(mbUrl, {id: 'mapbox.light', attribution: mbAttr}),
		streets  = L.tileLayer(mbUrl, {id: 'mapbox.streets',   attribution: mbAttr});

	var map = L.map('map', {
		center: [47.04070,9.06765],
		zoom: 16,
		layers: [grayscale, cities]
	});


	L.control.layers(baseLayers, overlays).addTo(map);

